import { buildLineStringFromSegments } from '@/services/lineStringService'
import type { Track } from '@/types/tour'

export const getBestTrackLineString = (
  track: Pick<Track, 'pointsLineReduced5m' | 'pointsLineReduced500m' | 'segments'>,
): string | undefined =>
  track.pointsLineReduced5m ??
  track.pointsLineReduced500m ??
  buildLineStringFromSegments(track.segments ?? [])
